<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogData" v-loading="trackloading">
      <div v-if="!trackloading">
        <div class="qwq">
          <div>
            <h3 class="steps_h3" v-if="!isExp">{{ $t('alert.youItemInformation') }}</h3>
            <h3 class="steps_h3" v-if="isExp">{{expList.State>=3?$t('alert.youItemDelivered'):$t('alert.youItemTransit') }}</h3>
            <div class="steps_box">
              <div>
                <div class="dot first greed">
                  <span class="yes el-icon-check"></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div class="steps_txt first">
                  {{ $t('base.shipped') }}<br>{{expList.ldate|setTimeS}}
                </div>
              </div>
              <div>
                <div class="dot" :class="expList.State>=2?'greed':''">
                  <span></span>
                  <span></span>
                  <span class="yes el-icon-check"></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div class="steps_txt">
                  {{ $t('base.inTransit') }}
                </div>
              </div>
              <div>
                <div class="dot" :class="expList.State>=3?'greed':''">
                  <span></span>
                  <span></span>
                  <span class="yes el-icon-check"></span>
                </div>
                <div class="steps_txt">
                  {{ $t('base.delivered') }}<br>{{expList.ndate|setTimeS}}
                </div>
              </div>
            </div>
            <div class="steps_title">{{expList.ShipperCode}}<span class="text_blue">#{{expList.LogisticCode}}</span></div>
          </div>
        </div>
        <el-scrollbar>
        <div class="track_box_dialog" ref="getHeight" v-if="isExp" >
          <div class="steps_list" v-for="(item,index) in expList.Traces" :key='index'>
            <div class="steps_list_up">
              <span class="time">{{item.AcceptTime|setTimeSS}}</span>
              <span class="dott"></span>
              <span class="add">{{item.AcceptStation}}</span>
            </div>
            <div class="steps_line"></div>
          </div>
        </div>
        </el-scrollbar>
      </div>
    </div>
    <div slot="footer" class="dialog_footer" style="margin: 0;">
      <el-button type="primary" @click="handleClose">{{ $t('base.ok') }}</el-button>
    </div>
  </el-dialog>
  <!-- <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogData" v-loading="trackloading">
      <h3 class="steps_h3" style="font-size:14px;" v-if="expList==null">Your item has no logistics information.</h3>
      <h3 class="steps_h3" v-if="expList!=null">Your item was delivered.</h3>
      <div v-if="expList!=null">
        <div class="steps_box">
          <div>
            <div class="dot first greed">
              <span class="yes el-icon-check"></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="steps_txt first">
              Shipped<br>{{expList.ldate|setTimeS}}
            </div>
          </div>
          <div>
            <div class="dot" :class="expList.State>=2?'greed':''">
              <span></span>
              <span></span>
              <span class="yes el-icon-check"></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="steps_txt">
              In transit
            </div>
          </div>
          <div>
            <div class="dot" :class="expList.State>=3?'greed':''">
              <span></span>
              <span></span>
              <span class="yes el-icon-check"></span>
            </div>
            <div class="steps_txt">
              Delivered<br>{{expList.ndate|setTimeS}}
            </div>
          </div>
        </div>
        <div class="steps_title">{{expList.ShipperCode}}<span class="text_blue">#{{expList.LogisticCode}}</span></div>

        
        <div class="track_box_dialog" style="height:1000px;">
          <div class="steps_list" v-for="(item,index) in expList.Traces" :key='index'>
            <div class="steps_list_up">
              <span class="time">{{item.AcceptTime|setTimeSS}}</span>
              <span class="dott"></span>
              <span class="add">{{item.AcceptStation}}</span>
            </div>
            <div class="steps_line"></div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog_footer" style="margin: 0;">
      <el-button type="primary" @click="handleClose">OK</el-button>
    </div>
  </el-dialog> -->
</template>
<script>
import { getTime } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      expList: null,
      isExp: false,
      trackloading: true,
      listHeight: 0,
    }
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {}
  },
  filters: {
    setTimeS(val) {
      if (val) {
        val = val.toString().replace(/-/g, "/")
      }
      var time = getTime(val, -8, 0, 'cn')
      return time.indexOf('Invalid') != -1 ? '' : time
    },
    setTimeSS(val) {
      if (val) {
        val = val.toString().replace(/-/g, "/")
      }
      var time = getTime(val, -8, 0, 'cn')
      return time.indexOf('Invalid') != -1 ? '' : time
    },
  },
  created() {
    this.GetExpress(this.list)
  },
  mounted() {
    let that = this
    that.$nextTick(() => {
      this.listHeight = this.$refs.getHeight.offsetHeight;
      console.log(this.listHeight)
    })
  },
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'express', false)
    },
    // 获取订单物流信息
    GetExpress(obj) {
      let that = this;
      that.expList = '';
      that.isExp = false
      that.trackloading = true
      let data = { LogisticCode: obj.ExpressNumber, ShipperCode: obj.ExpressCode, Mobile: obj.ExpressPhone, OrderCode: obj.ID }
      // let data = { LogisticCode: 'ES10019457712020001010001E0N', ShipperCode: 'ORANGECONNEX', Mobile: obj.ExpressPhone, OrderCode: obj.ID }
      this.$get(this.$interface.GetExpressInfoByShipperCode, data).then(res => {
        if (res.Result != 0) {
          if (res.Data == null) {
            that.expList = res.Data
          } else {
            if (res.Data.Traces.length > 0) {
              res.Data.ldate = res.Data.Traces[0].AcceptTime
              if (res.Data.State == '3') {
                let leng = res.Data.Traces.length - 1
                res.Data.ndate = res.Data.Traces[leng].AcceptTime
              }
              that.isExp = true
              that.expList = res.Data
            } else {
              that.expList = res.Data
            }
          }
        } else {
          that.expList = res.Data
        }
        that.trackloading = false
        //console.log(res)
      })
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";

/deep/ .el-dialog__body {
  padding: 12px 20px;
}

/deep/ .el-dialog {
  overflow-y: hidden;
}

.track_box_dialog {
  min-height: 0px;
  max-height: 200px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/express.vue